import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {NewsFormComponent} from './news/news-form/news-form.component';
import {AuthGuard} from './auth.guard';

const routes: Routes = [
  {path: '**', component: NewsFormComponent, canActivate: [AuthGuard]}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
